export default __webpack_public_path__ + "static/media/ss5.ed713850.jpg";